<page-title [value]="'About' | translate" />
<div>
  <div class="d-flex">
    <div class="w-50">
      <h2 translate>About</h2>
      <p>
        <img class="logo" src="/assets/logo.svg" width="260px" [alt]="'Logo' | translate" />
      </p>
    </div>
    @if (partnerInfo) {
      <div class="w-50">
        <h2 translate>Serviced by</h2>
        <img [src]="partnerInfo.logo" width="300px" [alt]="'Partner logo' | translate" />
      </div>
    }
  </div>
  <div class="d-flex">
    <div class="w-50 selectable" data-test-qa="elementsSection">
      <h3 data-test-qa="name">syslink GmbH</h3>
      <p [innerHTML]="trademarkString$ | async"></p>
      <div class="row">
        <div class="col-sm-5">
          <label translate>Address:</label>
          <br />
          syslink GmbH
          <br />
          Parkstraße 31
          <br />
          40477 Düsseldorf
          <br />
          Germany
        </div>
        <div class="col-sm-7">
          <p>
            <label translate>Phone:</label>
            <br />
            <span data-test-qa="phone">+492117495350</span>
          </p>
          <p>
            <a
              class="btn btn-outline-primary"
              href="https://elements.tv"
              target="_blank"
              data-test-qa="website"
            >
              <i class="far fa-globe"></i>
              <span translate>Website</span>
            </a>
          </p>
        </div>
      </div>
    </div>
    @if (partnerInfo) {
      <div class="w-50 selectable" data-test-qa="partnerSection">
        <h3 data-test-qa="name">{{ partnerInfo.name }}</h3>
        <p translate>For service requests:</p>
        <div class="row">
          <div class="col-sm-6">
            <label translate>Address:</label>
            <br />
            @if (partnerInfo.address) {
              <div class="address" data-test-qa="address">
                {{ partnerInfo.address }}
              </div>
            }
          </div>
          <div class="col-sm-6">
            @if (partnerInfo.phone) {
              <p>
                <label translate>Phone:</label>
                <br />
                <span data-test-qa="phone">{{ partnerInfo.phone }}</span>
              </p>
            }
            @if (partnerInfo.website) {
              <p>
                <a
                  class="btn btn-outline-primary"
                  [href]="partnerInfo.website"
                  target="_blank"
                  data-test-qa="website"
                >
                  <i class="far fa-globe"></i>
                  <span translate>Website</span>
                </a>
              </p>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
